window.$win = $win = $(window);
window.$bod = $bod = $('body');
window.$mainNav = $mainNav = $('#nav-main');
window.$mainNav = $subNav = $('#sub-nav');
window.docCookies = docCookies = require('../dependencies/cookies');

$win.on('load', () => {
  $('#jobs-loading-container').css('display', 'none');
  if (typeof window.drift === 'function') {
    drift.on('ready', function () {
      const $chatButton = $('#mobile-lets-chat');
      $chatButton.find('.fa-spinner').hide();
      $chatButton.find('.chat-text').show();
      $chatButton.attr('data-track-click', 'Mobile CTA Bar, CTA, Let\'s Chat')
    });

    if ($win.width() >= 768) {
      drift.on('ready', function (api) {
        api.widget.show();
      });
    } else {
      drift.on('ready', function (api) {
        api.widget.hide();
        drift.on('sidebarClose', function (e) {
          if (e.data.widgetVisible) {
            api.widget.hide();
          }
        });
      });
    }
  }
});

$(document).ready(function () {
  $bod.on('click', '.clickable', function () {
    var url = $(this).data('href');

    if (url) {
      window.location = url;
    }
  })

  // Functions for slideshows //
  if ($('.carousel-hero').length > 0) {
    $('.carousel-hero').carousel({
      interval: 5000
    });
  }

  if ($('.carousel-testimonials').length > 0) {
    $('.carousel-testimonials').carousel({
      interval: 6000
    });
  }

  const $chatButton = jQuery('#mobile-lets-chat');
  $chatButton.on('click', function () {
    if (typeof drift === 'function') {
      if (window.location.href.indexOf('/es') > -1) {
        drift.api.startInteraction({ interactionId: 107355, goToConversation: true });
      } else if (window.location.href.indexOf('/en-au') > -1) {
        drift.api.startInteraction({ interactionId: 69901, goToConversation: true });
      } else if (window.location.href.indexOf('/en-ca') > -1) {
        drift.api.startInteraction({ interactionId: 85369, goToConversation: true });
      } else {
        drift.api.startInteraction({ interactionId: 45528, goToConversation: true });
      }
    }
  });
});

